import { styled } from "@mui/material";
import { ActionBar, actionBarClasses } from "../../../ActionBar/index.js";
import { editorQuickInsertToolbarName } from "../classes.js";
const Root = styled(ActionBar, {
  name: editorQuickInsertToolbarName,
  slot: "Root",
  overridesResolver: (_props, styles) => [styles.root]
})(({ theme, ownerState }) => ({
  minWidth: 0,
  overflow: "hidden",
  flexDirection: "row-reverse",
  [`.${actionBarClasses.menuButton}`]: {
    color: ownerState?.disabled ? (theme.vars ?? theme).palette.action.disabled : (theme.vars ?? theme).palette.primary.main
  }
}));
export {
  Root
};
//# sourceMappingURL=Root.js.map
